import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const AngleBetweenTwoSurfaces = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Angle between Two Surfaces"
    videos={[
      "https://www.youtube.com/embed/CWwFWMkJdlU?list=PLhSp9OSVmeyIeKw3AdI2e3R9Q2IKzPcy7"
    ]}
    takeaways={[]}
    questions={[]}
    exampleVideos={[]}
  />
);
}

export default AngleBetweenTwoSurfaces;
